export default [
/*
  {
    name: 'menu.home',
    icon: 'ti-panel',
    collapsed: false,
    children: [{
      name: 'menu.saude.das.plantas',
      path: '/pages/home'
    }]
  },
  {
    name: 'menu.crud',
    icon: 'ti-layout-tab',
    collapsed: false,
    children: [{
      name: 'menu.crud.component.type',
      path: '/crud/ComponentType'
    }
    ]
  }*/
]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js